exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.key-member-display{display:flex;height:60px;align-items:center;margin-left:30px;margin-right:30px;overflow-x:auto;overflow-y:hidden}.key-member-display .divider{height:48px;border-left:1px solid;margin-left:0;margin-right:0;width:1px}.key-member-display .member-section{height:60px;display:flex}.key-member-display .member-section .divider{margin-top:12px;height:33px;border-left:1px solid #9b9b9b;margin-left:0;margin-right:0;width:1px}.key-member-display .member-section .key-member{display:flex;flex-direction:column;width:35px;align-items:center;margin-top:12px}.key-member-display .member-section .key-member .avatar-info{margin-left:0;margin-bottom:10px}.key-member-display .member-section .key-member .key-member-role{width:120px;text-align:center;font-family:Open Sans,sans-serif;font-weight:400;font-size:10px;color:#9b9b9b;letter-spacing:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.key-member-display .member-section .key-member .key-member-role__multiple-assigned{margin-top:10px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/KeyMemberDisplay/KeyMemberDisplay.scss
// module id = 1574
// module chunks = 0